import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

function ActivationSteps() {
  return (
    <div className="w-full flex justify-center">
      <div className="relative mx-auto bg-white px-5 py-5 w-full rounded-3xl max-w-[1260px] md:px-16 md:py-12 lg:my-20 lg:w-[calc(100%-2rem)] grid grid-cols-[1fr] md:grid-cols-[1fr_1fr] md:my-32 my-16  gap-10 md:gap-12 border">
        <div>
          <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] mb-[30px]">
            In 3 simpele stappen je vrijblijvende offerte aanvragen
          </h2>
          <div>
            <ul className="flex flex-col mb-8 gap-10">
              <li className="relative before:bg-[#D5F0F6] before:content-[''] before:absolute before:w-[1.5px] before:h-[calc(100%_-_8px)] before:rounded-[1px] before:left-[15px] before:top-10 before:bottom-0">
                <div className="flex gap-4 items-baseline">
                  <span className="w-8 h-8 justify-center items-center gap-2.5 shrink-0 px-2.5 py-2 rounded-full text-base md:text-lg flex text-center bg-[#D5F0F6] text-[#17354A]">
                    1
                  </span>
                  <div className="text-[#17354A] leading-[1.56] text-[16px] md:text-[18px] font-normal flex">
                    Vul het offerteformulier in
                  </div>
                </div>
              </li>
              <li className="relative before:bg-[#D5F0F6] before:content-[''] before:absolute before:w-[1.5px] before:h-[calc(100%_-_8px)] before:rounded-[1px] before:left-[15px] before:top-10 before:bottom-0">
                <div className="flex gap-4 items-baseline">
                  <span className="w-8 h-8 justify-center items-center gap-2.5 shrink-0 px-2.5 py-2 rounded-full text-base md:text-lg flex text-center bg-[#D5F0F6] text-[#17354A]">
                    2
                  </span>
                  <div className="text-[#17354A] leading-[1.56] text-[16px] md:text-[18px] font-normal flex">
                    Wij bellen je voor een installatiebespreking
                  </div>
                </div>
              </li>
              <li>
                <div className="flex gap-4 items-baseline">
                  <span className="w-8 h-8 justify-center items-center gap-2.5 shrink-0 px-2.5 py-2 rounded-full text-base md:text-lg flex text-center bg-[#4BB543] text-white">
                    <Check className="w-4 h-4" />
                  </span>
                  <div className="text-[#17354A] leading-[1.56] text-[16px] md:text-[18px] font-normal flex">
                    Installatie na akkoord op de offerte
                  </div>
                </div>
              </li>
            </ul>
            <Link
              to="/offerte"   aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"

              className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] text-base px-5 h-12 leading-[48px] text-[#17354A] hover:opacity-60 focus:opacity-60 w-full md:w-fit"
              style={{ minWidth: "206px" }}
            >
              <span className="flex items-center gap-1">
                Vraag vrijblijvend je offerte aan
                <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          </div>
        </div>

        <div className=" inline-block w-full h-fit">
          <img
            src="/images/mirt.png"
            alt="Elektraaanleggen.nl"
            className="hidden md:block absolute bottom-0 md:max-w-[400px] lg:max-w-[600px] top-auto w-full h-auto rounded-xl"
          />
        </div>
      </div>
    </div>
  );
}

export default ActivationSteps;
